import { CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material'
import React,{useState} from 'react'

import { useAlert } from '../../../../context/AlertContext';
import userRoleServices from '../userRoleServices';
import { useAppData } from '../../../../context/AppDataContext';
import userServices from '../userServices';

function UserRoleInput({userDetails,getUserDetails}) {
    const [dialogStatus, setDialogStatus] = useState(false);
    const {userRoleDD} = useAppData();
    const [savingInProgress, setSavingStatus] = useState(false);
    
    const {AppAlert} =  useAlert();

    
    const updateUserRole = (role)=>{
        let payload = {
            id:userDetails.id,
            role:role,
            changePassword:false
        }
        userServices.save(payload).then(res=>{
            AppAlert(res.msg);
            getUserDetails();
            setDialogStatus(false);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    return (
        <>
            <button className='btn btn-outline-primary' onClick={()=>{setDialogStatus(true)}}>{userDetails.roleTitle}</button>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                maxWidth="sm"
            >
                <DialogTitle>Select Role</DialogTitle>
                <DialogContent>
                    <ul className="list-group">
                        {userRoleDD && userRoleDD.map(userRole=>
                            <button key={userRole.value} 
                                type='button' className="list-group-item list-group-item-action"
                                onClick={()=>updateUserRole(userRole.value)}
                            >
                                {userRole.label}
                            </button>
                        )}
                    </ul>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default UserRoleInput
